// src/components/ProtectedRoute.jsx

import { Navigate } from "react-router-dom";
import { getUser } from "./AuthService";

function ProtectedRoute({ children }) {
  const user = getUser();

  if (!user) {
    return <Navigate to="/" />;
  }

  return children;
}

export default ProtectedRoute;